

















import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import CustomerUser, { CUSTOMER_AUTHORITY } from "@/model/customerUser";
import { ADMIN_TYPE } from "@/common/constant";
const authStore = namespace("Auth");

@Component({
  name: "Error",
})
export default class Error extends Vue {
  @authStore.Getter
  getUserType!: string;
  @authStore.Getter
  getCustomerUser!: CustomerUser;
  public backToTop() {
    if (this.getUserType == ADMIN_TYPE) {
      this.$router.push({ name: "admin.order-histories" });
    } else if (
      this.getCustomerUser &&
      this.getCustomerUser.account_authority ==
        CUSTOMER_AUTHORITY.ADMIN_CUSTOMER
    ) {
      this.$router.push({ name: "admin-customer.order-histories" });
    } else {
      this.$router.push({ name: "customer.default" });
    }
  }
}
